import { render, staticRenderFns } from "./ReferalPopup.vue?vue&type=template&id=359f3976&scoped=true"
import script from "./ReferalPopup.vue?vue&type=script&lang=js"
export * from "./ReferalPopup.vue?vue&type=script&lang=js"
import style0 from "./ReferalPopup.vue?vue&type=style&index=0&id=359f3976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359f3976",
  null
  
)

export default component.exports